import { Component } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

/**
 * Building block to display readonly information
 */
@CoreBuildingBlock('info-row-obfuscate')
@Component({
  selector: 'cu-info-row-obfuscate',
  templateUrl: './info-row-obfuscate.component.html',
  standalone: false
})
export class InfoRowObfuscateComponent extends CoreBuildingBlockControlBaseComponent {
  /** showValueFlag   */
  public shouldShowValue = false;

  /**
   * ShowContent if available.
   */
  public get showContent(): boolean {
    return !this.field.config.content && this.field.data.value !== null;
  }

  /**
   * If actual textbox value is Valid, and its focus is out of this this text,
   * then hide the actual textbox.
   */
  public get showObfuscatedValue(): boolean {
    return this.field.valid && !this.shouldShowValue;
  }

  /** Display actual textbox to display Unobfuscated value.  */
  public showUnObfuscatedValue(): void {
    this.shouldShowValue = true;
    setTimeout(() => {
      this.shouldShowValue = false;
    }, 500);
  }
}
